import React from "react";
import "./App.css";
import TicTacRoutes from "./Routes/TicTacRoutes";

function App() {

  return <TicTacRoutes />;
}

export default App;
